module.exports = __webpack_public_path__ + "img/139.f38d6189.jpg";